var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_98221)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41632 0.695012C8.52789 0.80659 8.52789 0.987495 8.41632 1.09907L0.987745 8.52764C0.876166 8.63922 0.695262 8.63922 0.583684 8.52764C0.472105 8.41607 0.472105 8.23516 0.583684 8.12358L8.01226 0.695012C8.12383 0.583434 8.30474 0.583434 8.41632 0.695012Z",
    fill: "#AF2828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583684 0.695012C0.695262 0.583434 0.876166 0.583434 0.987745 0.695012L8.41632 8.12358C8.52789 8.23516 8.52789 8.41607 8.41632 8.52764C8.30474 8.63922 8.12383 8.63922 8.01226 8.52764L0.583684 1.09907C0.472105 0.987495 0.472105 0.80659 0.583684 0.695012Z",
    fill: "#AF2828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_98221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.5 0.611328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9ed357cabb194d91f29e6becf17665ce.svg";
export { ForwardRef as ReactComponent };